interface IconProps {
  color?: string
}

export const Id = ({ color }: IconProps) => {
  return (
    <svg
      aria-hidden="true"
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 10.7871C4 8.87974 5.55599 7.3335 7.47541 7.3335H24.5246C26.444 7.3335 28 8.87974 28 10.7871V21.2132C28 23.1206 26.444 24.6668 24.5246 24.6668H7.47541C5.55599 24.6668 4 23.1206 4 21.2132V10.7871ZM7.47541 9.02773C6.49759 9.02773 5.70492 9.81544 5.70492 10.7871V21.2132C5.70492 22.1849 6.49759 22.9726 7.47541 22.9726H24.5246C25.5024 22.9726 26.2951 22.1849 26.2951 21.2132V10.7871C26.2951 9.81544 25.5024 9.02773 24.5246 9.02773H7.47541Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5629 12.2859C11.7225 12.2859 11.0412 12.9629 11.0412 13.7981C11.0412 14.6333 11.7225 15.3103 12.5629 15.3103C13.4034 15.3103 14.0847 14.6333 14.0847 13.7981C14.0847 12.9629 13.4034 12.2859 12.5629 12.2859ZM9.33626 13.7981C9.33626 12.0272 10.7809 10.5916 12.5629 10.5916C14.345 10.5916 15.7896 12.0272 15.7896 13.7981C15.7896 15.569 14.345 17.0046 12.5629 17.0046C10.7809 17.0046 9.33626 15.569 9.33626 13.7981Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2788 14.8154C19.2788 14.3476 19.6604 13.9683 20.1312 13.9683H22.7542C23.225 13.9683 23.6066 14.3476 23.6066 14.8154C23.6066 15.2833 23.225 15.6625 22.7542 15.6625H20.1312C19.6604 15.6625 19.2788 15.2833 19.2788 14.8154Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.2788 17.4219C19.2788 16.9541 19.6604 16.5748 20.1312 16.5748H22.7542C23.225 16.5748 23.6066 16.9541 23.6066 17.4219C23.6066 17.8898 23.225 18.2691 22.7542 18.2691H20.1312C19.6604 18.2691 19.2788 17.8898 19.2788 17.4219Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5855 19.5611C11.1519 19.5611 9.90758 20.3123 9.40671 20.8397C9.0836 21.18 8.54408 21.1956 8.20166 20.8745C7.85924 20.5534 7.84359 20.0172 8.1667 19.677C8.94462 18.8577 10.6208 17.8668 12.5855 17.8668C14.5502 17.8668 16.2263 18.8577 17.0042 19.677C17.3273 20.0172 17.3117 20.5534 16.9693 20.8745C16.6268 21.1956 16.0873 21.18 15.7642 20.8397C15.2633 20.3123 14.019 19.5611 12.5855 19.5611Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
